export default __webpack_public_path__ + "static/color-analysis-skin-undertone-39a30bf8922211f7daed17d03705513c.jpg";